import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type CardProps = {
  $curved?: boolean;
  $hideBackButton?: boolean;
  $padding?: 'large' | 'medium' | 'small';
};

export const Card = styled.div<CardProps>`
  background: ${COLOR.WHITE};
  box-shadow: 0px 0px 10px ${rgba(COLOR.BLACK, 0.29)};
  margin-top: ${({ $hideBackButton }) => ($hideBackButton ? '0px' : '35px')};
  width: 100%;
  padding: ${({ $padding }) => {
    switch ($padding) {
      case 'large':
        return '90px';
      case 'medium':
        return '50px';
      case 'small':
        return '20px';
      default:
        return '50px';
    }
  }};
  box-sizing: border-box;
  ${({ $curved }) =>
    $curved
      ? css`
          box-shadow: 0px 3px 6px ${rgba(COLOR.BLACK, 0.29)};
          border-radius: 10px;
          height: 100%;
        `
      : ''}
`;
